import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const DigitalMarketing = () => {


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Breadcrumb Section */}
            <section className="breadcrumb-hero">
                <div className="breadcrumb-overlay"></div>
                <div className="breadcrumb-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="breadcrumb-title">
                                    Digital <span className="breadcrumb-highlight">Marketing</span>
                                </h1>
                                <Link to="/services" style={{ textDecoration: 'none' }}>
                                    <button className="breadcrumb-btn">
                                        <span>Our Services</span>
                                        <span className="breadcrumb-arrow">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </span>
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-pattern"></div>
            </section>

            {/* Hero Section */}
            <section className="digital-presence-hero">
                <div className="container">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-6">
                            <div className="hero-badge">
                                <span className="badge-dot"></span>
                                Award-Winning Digital Marketing Agency
                            </div>
                            <h2 className="intro-about-heading">
                                Accelerate Your Growth With
                                <span className="text-gradient"> Strategic Digital Marketing</span>
                            </h2>
                            <p className="hero-description">
                                Drive measurable results with <span className="text-blue-highlight">data-driven marketing strategies</span> that amplify your brand, engage your audience, and boost your ROI. From SEO to social media, we deliver excellence across all channels.
                            </p>
                            <div className="hero-buttons">
                                <button className="btn-hero-secondary">
                                    View Success Stories →
                                </button>
                            </div>
                            <div className="hero-stats">
                                <div className="stat-card">
                                    <h3 className="stat-number">300%</h3>
                                    <p className="stat-label">Avg ROI Growth</p>
                                </div>
                                <div className="stat-card">
                                    <h3 className="stat-number">750+</h3>
                                    <p className="stat-label">Campaigns Delivered</p>
                                </div>
                                <div className="stat-card">
                                    <h3 className="stat-number">98%</h3>
                                    <p className="stat-label">Client Satisfaction</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="hero-image-container">

                                <img src={require('../../assets/images/digital-marketing.jpg')} alt="Digital Marketing Hero" className="img-fluid rounded shadow-md" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Comprehensive Digital Marketing Solutions Section */}
            <section className="comprehensive-design-section py-5">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="expertise-badge">
                            Our Services
                        </div>
                        <h2 className="comprehensive-title">
                            Complete Digital Marketing Solutions
                        </h2>
                        <p className="comprehensive-subtitle">
                            Strategic services to boost your online presence and drive business growth
                        </p>
                    </div>

                    <div className="row g-4">
                        {/* SEO Services */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🔍</span>
                                </div>
                                <h3 className="solution-card-title">Search Engine Optimization</h3>
                                <p className="solution-card-description">
                                    Dominate search rankings with proven SEO strategies that drive organic traffic and increase visibility
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* Social Media Marketing */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">📱</span>
                                </div>
                                <h3 className="solution-card-title">Social Media Marketing</h3>
                                <p className="solution-card-description">
                                    Build engaged communities and amplify your brand across Facebook, Instagram, LinkedIn, and Twitter
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* PPC Advertising */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card highlighted">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">💰</span>
                                </div>
                                <h3 className="solution-card-title">PPC Advertising</h3>
                                <p className="solution-card-description">
                                    Maximize ROI with targeted Google Ads and social media advertising campaigns
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* Content Marketing */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">✍️</span>
                                </div>
                                <h3 className="solution-card-title">Content Marketing</h3>
                                <p className="solution-card-description">
                                    Engage your audience with compelling content that educates, entertains, and converts
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* Email Marketing */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">📧</span>
                                </div>
                                <h3 className="solution-card-title">Email Marketing</h3>
                                <p className="solution-card-description">
                                    Nurture leads and boost conversions with personalized email campaigns that deliver results
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* Analytics & Reporting */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">📊</span>
                                </div>
                                <h3 className="solution-card-title">Analytics & Reporting</h3>
                                <p className="solution-card-description">
                                    Data-driven insights and comprehensive reporting to track performance and optimize strategies
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="text-center mt-5">
                        <button className="btn-start-project">
                            Start Your Marketing Campaign →
                        </button>
                    </div>
                </div>
            </section>

            {/* Why Choose Profit Technologies */}
            <section className="bespoke-section py-5" style={{ backgroundColor: '#f8f9fa' }}>
                <div className="container">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-6">
                            <h2 className="section-main-title mb-4">
                                Why Choose Profit Technologies for Digital Marketing?
                            </h2>
                            <p className="section-description">
                                <strong>Your Growth Partner in the Digital Age</strong>
                            </p>
                            <p className="section-description">
                                At <strong>Profit Technologies</strong>, we don't just run campaigns – we drive transformative growth. Our team of certified digital marketing experts combines creativity with data-driven strategies to deliver measurable results that matter to your bottom line.
                            </p>
                            <p className="section-description">
                                From startups to Fortune 500 companies, we've helped businesses across industries achieve unprecedented digital success. Our integrated approach ensures every marketing dollar works harder to attract, engage, and convert your ideal customers.
                            </p>
                            <p className="section-description">
                                <strong>What makes us different:</strong>
                            </p>
                            <ul className="section-description" style={{ paddingLeft: '20px' }}>
                                <li>✓ Certified experts with 12+ years of digital marketing excellence</li>
                                <li>✓ Proven track record of 300%+ average ROI growth</li>
                                <li>✓ Advanced analytics and AI-powered optimization</li>
                                <li>✓ Transparent reporting with real-time campaign insights</li>
                                <li>✓ Customized strategies tailored to your business goals</li>
                                <li>✓ Full-service solutions from strategy to execution</li>
                            </ul>
                        </div>
                        <div className="col-lg-6">
                            <div className="bespoke-image-wrapper">
                                <img
                                    src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80"
                                    alt="Profit Technologies Digital Marketing"
                                    className="img-fluid rounded"
                                    style={{ boxShadow: '0 10px 40px rgba(0,0,0,0.1)' }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Marketing Channels We Master */}
            <section className="comprehensive-design-section py-5">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="expertise-badge">
                            Marketing Channels
                        </div>
                        <h2 className="comprehensive-title">
                            Platforms & Tools We Master
                        </h2>
                        <p className="comprehensive-subtitle">
                            Leveraging the best tools and platforms for maximum marketing impact
                        </p>
                    </div>

                    <div className="row g-4">
                        {/* Google Ads */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🎯</span>
                                </div>
                                <h3 className="solution-card-title">Google Ads</h3>
                                <p className="solution-card-description">
                                    Targeted PPC campaigns with optimized ad spend and conversion tracking
                                </p>
                            </div>
                        </div>

                        {/* Facebook & Instagram */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">📘</span>
                                </div>
                                <h3 className="solution-card-title">Meta Platforms</h3>
                                <p className="solution-card-description">
                                    Advanced Facebook & Instagram advertising with precise audience targeting
                                </p>
                            </div>
                        </div>

                        {/* LinkedIn Marketing */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">💼</span>
                                </div>
                                <h3 className="solution-card-title">LinkedIn Ads</h3>
                                <p className="solution-card-description">
                                    B2B marketing excellence with professional audience engagement
                                </p>
                            </div>
                        </div>

                        {/* SEO Tools */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🔧</span>
                                </div>
                                <h3 className="solution-card-title">SEO Tools</h3>
                                <p className="solution-card-description">
                                    SEMrush, Ahrefs, Moz for comprehensive SEO optimization
                                </p>
                            </div>
                        </div>

                        {/* Email Platforms */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">📬</span>
                                </div>
                                <h3 className="solution-card-title">Email Automation</h3>
                                <p className="solution-card-description">
                                    Mailchimp, HubSpot, ActiveCampaign for powerful email marketing
                                </p>
                            </div>
                        </div>

                        {/* Analytics */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">📈</span>
                                </div>
                                <h3 className="solution-card-title">Analytics Suite</h3>
                                <p className="solution-card-description">
                                    Google Analytics, Tag Manager, Data Studio for deep insights
                                </p>
                            </div>
                        </div>

                        {/* Content Management */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">📝</span>
                                </div>
                                <h3 className="solution-card-title">Content Tools</h3>
                                <p className="solution-card-description">
                                    WordPress, Contentful, Canva for content creation and management
                                </p>
                            </div>
                        </div>

                        {/* Marketing Automation */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">⚡</span>
                                </div>
                                <h3 className="solution-card-title">Automation</h3>
                                <p className="solution-card-description">
                                    HubSpot, Marketo, Zapier for streamlined marketing workflows
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Marketing Process */}
            <section className="comprehensive-design-section py-5" style={{ backgroundColor: '#ffffff' }}>
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="expertise-badge">
                            Our Methodology
                        </div>
                        <h2 className="comprehensive-title">
                            How We Drive Your Success
                        </h2>
                        <p className="comprehensive-subtitle">
                            A proven 6-step process that delivers consistent, measurable results
                        </p>
                    </div>

                    <div className="row g-4">
                        {/* Research & Strategy */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🔬</span>
                                </div>
                                <h3 className="solution-card-title">1. Research & Strategy</h3>
                                <p className="solution-card-description card-text-dst">
                                    Deep market analysis, competitor research, and audience insights to craft winning strategies
                                </p>
                            </div>
                        </div>

                        {/* Campaign Planning */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">📋</span>
                                </div>
                                <h3 className="solution-card-title">2. Campaign Planning</h3>
                                <p className="solution-card-description card-text-dst">
                                    Detailed campaign blueprints with clear objectives, KPIs, and tactical roadmaps
                                </p>
                            </div>
                        </div>

                        {/* Content Creation */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🎨</span>
                                </div>
                                <h3 className="solution-card-title">3. Content Creation</h3>
                                <p className="solution-card-description card-text-dst">
                                    Compelling content that resonates with your audience and drives engagement
                                </p>
                            </div>
                        </div>

                        {/* Campaign Execution */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🚀</span>
                                </div>
                                <h3 className="solution-card-title">4. Campaign Launch</h3>
                                <p className="solution-card-description card-text-dst">
                                    Precise execution across multiple channels with coordinated timing for maximum impact
                                </p>
                            </div>
                        </div>

                        {/* Monitoring & Optimization */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">⚙️</span>
                                </div>
                                <h3 className="solution-card-title">5. Monitor & Optimize</h3>
                                <p className="solution-card-description card-text-dst">
                                    Continuous monitoring with real-time adjustments to maximize performance and ROI
                                </p>
                            </div>
                        </div>

                        {/* Reporting & Scaling */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">📊</span>
                                </div>
                                <h3 className="solution-card-title">6. Report & Scale</h3>
                                <p className="solution-card-description card-text-dst">
                                    Transparent reporting with actionable insights and strategies to scale successful campaigns
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default DigitalMarketing;
